/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function AbstractShapes(props) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/abstractShapes.glb')
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Plane.geometry}
        material={materials['Material.001']}
        position={[0.42, 0, -8.07]}
        rotation={[1.52, 0, 0]}
        scale={[2.42, 2.42, 2.42]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Plane001.geometry}
        material={nodes.Plane001.material}
        position={[-4.27, -0.02, -5.45]}
        rotation={[1.52, 0, 0]}
        scale={[2.42, 2.42, 2.42]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Plane002.geometry}
        material={nodes.Plane002.material}
        position={[3.82, -0.07, -4.57]}
        rotation={[-0.96, 0.69, -2.4]}
        scale={[0.69, 0.69, 0.69]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Plane003.geometry}
        material={nodes.Plane003.material}
        position={[3.3, 3.11, -27.54]}
        rotation={[-0.85, 0.63, -2.75]}
        scale={[0.69, 0.69, 0.69]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Plane004.geometry}
        material={nodes.Plane004.material}
        position={[-4.85, 1.72, -11.33]}
        rotation={[-0.71, -0.22, 2.96]}
        scale={[0.69, 0.69, 0.69]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Plane005.geometry}
        material={nodes.Plane005.material}
        position={[6.44, 2.58, -11.48]}
        rotation={[-1.88, 0, 2.04]}
        scale={[0.43, 0.43, 0.43]}
      />
    </group>
  )
}

useGLTF.preload('/abstractShapes.glb')
